import { useStore, log } from "../../index";

const setIsRefreshInProgress = (value: boolean) => {
  useStore.setState({ isRefreshInProgress: value });
};
const RefreshCustomFunctions = async (): Promise<void> => {
  try {
    const refreshMode = useStore.getState().refreshMode;
    // Set refresh in progress at the start
    setIsRefreshInProgress(true);

    await Excel.run(async (context) => {
      if (refreshMode === "Workbook") {
        context.application.calculate(Excel.CalculationType.full);
        const sheetsCollection = context.workbook.worksheets;
        sheetsCollection.load("items/name");
        await context.sync();
        const sheets = sheetsCollection.items;

        await waitCalculationDone(context); // Wait until calculation is done
        
        for (let sheet of sheets) {
          if (sheet.name !== "DR Log") {
            await logErrorCells(sheet);
          }
        }
      } else if (refreshMode === "Sheet") {
        const sheet = context.workbook.worksheets.getActiveWorksheet();
        sheet.calculate(true);
        await waitCalculationDone(context); // Wait until calculation is done
        await logErrorCells(sheet);
      }

      await context.sync();

    });
  } catch (error) {
    if (error.code !== Excel.ErrorCodes.itemNotFound) {
      console.error(error);
      log.error(`RefreshCustomFunctions: Error name: ${error.name}, Error code: ${error.code}`);
      throw error;
    } else {
      console.info(error);
      log.info(`RefreshCustomFunctions: Error name: ${error.name}, Error code: ${error.code}`);
    }
  } finally {
    // Ensure refresh in progress is false in any case
    setIsRefreshInProgress(false);
  }
};

const waitCalculationDone = async (context: Excel.RequestContext) => {
  context.application.load("calculationState");
  await context.sync();
  let calculationState = context.application.calculationState;
  log.info(`Calculation State: ${calculationState}`);

  // Wait until calculation state is 'Done', but break after 600 iterations (5 minutes) to avoid infinite loop
  let i = 0;
  while (calculationState !== Excel.CalculationState.done && i < 600) {
    await new Promise(resolve => setTimeout(resolve, 500));
    context.application.load("calculationState");
    await context.sync();
    calculationState = context.application.calculationState;
    log.debug(`Calculation State: ${calculationState} (iteration ${i + 1})`);
    i++;
  }
  if (i >= 600 && calculationState !== Excel.CalculationState.done) {
    log.warn("Calculation did not complete after 5 minutes.");
  } else {
    log.info("Calculation completed.");
  }
};

/* Find cells with errors and prompt user about incorrect input. Clear cells with valid input */
const logErrorCells = async (sheet: Excel.Worksheet) => {
  const usedRange = sheet.getUsedRange();
  usedRange.load(["formulas", "valuesAsJson"]);
  await usedRange.context.sync();

  const errorCells = [];
  usedRange.valuesAsJson.forEach((row, r) => {
    row.forEach((cell, c) => {
      const formula = usedRange.formulas[r][c];
      if (
        cell?.type === "Error" &&
        //cell?.errorType !== "Busy" &&
        (formula.includes("CLAUSION."))
      ) {
        errorCells.push({
          range: usedRange.getCell(r, c),
          errorType: (cell as any).errorType,
        });
      }
    });
  });

  if (errorCells.length > 0) {
    errorCells.forEach(({ range }) => range.load("address"));
    await usedRange.context.sync();
    errorCells.forEach(({ range, errorType }) => {
      if (errorType === "Busy") {
        log.warn(`Cell ${range.address} has marked as busy in CLAUSION custom function. ErrorType: ${errorType}`);
      } else {
        log.error(`Cell ${range.address} has an error in CLAUSION custom function. ErrorType: ${errorType}`);
      }
    });
  }
};

export default RefreshCustomFunctions;
